import { render } from "./Rule.vue?vue&type=template&id=c9382422&ts=true"
import script from "./Rule.vue?vue&type=script&lang=ts"
export * from "./Rule.vue?vue&type=script&lang=ts"

import "./Rule.vue?vue&type=style&index=0&id=c9382422&lang=scss"

import exportComponent from "D:\\work\\fengmian\\Activity\\2023qixi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__